import { NavLink, useLocation } from "react-router-dom";
import { Mui } from "@osu/react-ui";
import { mergeSxStyles } from "../../styles/util";

const linkStyles = ({ isSame, disableHighlightCurrent }) => [
  (theme) => {
    const isDarkMode = theme?.palette?.mode === "dark";
    const darkGrays = theme?.palette?.brand?.gray?.darker;
    const lightGrays = theme?.palette?.brand?.gray?.lighter;
    let cls = {
      textTransform: "none",
      borderBottom: `4px solid transparent`,
      height: '100%',
      borderRadius: 0,
      padding: `.25rem 0`,
      alignSelf: "bottom",
      color: theme?.palette?.textColor,
      [`&.${Mui.buttonClasses.textPrimary}`]: {
        color: theme?.palette?.textColor,
      },
      "&:hover": {
        backgroundColor: (isDarkMode ? darkGrays : lightGrays)?.[80],
        borderBottomColor: (isDarkMode ? lightGrays : darkGrays)?.[40],
      },
    };
    
    if(isSame && !disableHighlightCurrent) {
        cls.borderBottomColor = theme?.palette?.brand?.gray?.main
    }
    return cls
  }
]

const NavbarLink = ({ to, children, disableHighlightCurrent, sx, ...rest }) => {
  const { pathname } = useLocation()  
  const isSame = pathname === to
  const styles = mergeSxStyles(linkStyles({ isSame, disableHighlightCurrent, children }), sx)
  const props = {
    component: NavLink,
    ...rest,
    to
  }
  return (
    <Mui.Button
      sx={styles}
      {...props}
    >
      {children}
    </Mui.Button>
  );
};

export default NavbarLink;
